import React from "react"
import { RadioInput } from "@mindz/react-admin-ui"
import { withStyles } from "@mindz/react-hoc"

import styles from "./index.module.css"

export const RadioInputBox = withStyles(styles)(({ ...props }) => <RadioInput.KauflandBox {...props} />)
export default withStyles(styles)(({ ...props }) => <RadioInput.Kaufland {...props} />)
